import React from 'react';

import config from 'configs/app';
import NavigationDesktop from 'ui/snippets/navigation/horizontal/NavigationDesktop';

const NavBar = () => {
  if (config.UI.navigation.layout === 'vertical') {
    return null;
  }

  return <NavigationDesktop/>;
};

export default React.memo(NavBar);
